import React, { Component } from "react";
import Axios from "axios";
import Constant from "../Constant";
import "../../css/style.css";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit, faTrashAlt } from "@fortawesome/free-solid-svg-icons";
import { getAccessToken } from "../../hooks/AccessToken";

class RegistrationCategories extends Component {
  state = {
    DataList: [],
    ERROR: true,
  };

  componentDidMount() {
    this.fetchCategories();
  }

  fetchCategories = async () => {
    try {
      const token = getAccessToken();
      const response = await Axios.get(
        Constant.apiBasePath + "registration-categories/get-all",
        {
          headers: { token },
        }
      );
      const { data } = response.data;
      this.setState({ DataList: data, ERROR: false });
    } catch (err) {
      console.error("Error fetching registration categories:", err);
      this.setState({ ERROR: true });
    }
  };

  deleteCategory = async (id) => {
    const token = getAccessToken();
    try {
      const response = await Axios.delete(
        Constant.apiBasePath + `registration-categories/${id}`,
        {
          headers: { token },
        }
      );
      if (response.data.status === Constant.statusSuccess) {
        alert("Category deleted successfully!");
        this.fetchCategories(); // Refresh the list after deletion
      } else {
        alert(response.data.message);
      }
    } catch (err) {
      console.error("Error deleting category:", err);
      alert("Something went wrong. Please try again later.");
    }
  };

  render() {
    const { DataList } = this.state;

    return (
      <div className="content-page contest-submissions-page contest-management-page registration-categories-page event-consistent-page">
        <div className="content page-content-spaced">
          <div className="event-management-header">
            <div className="header-content">
              <div className="header-title">
                <h4 className="page-title-heading">Registration Categories</h4>
                <p className="header-subtitle">
                  Manage category options used across registration forms.
                </p>
              </div>
              <div className="header-actions">
                <Link
                  to="/add-registration-category"
                  className="btn btn-primary btn-add-event contest-add-match"
                >
                  + Add New
                </Link>
              </div>
            </div>
          </div>

          <div className="event-management-body">
              <div className="card contest-like-card">
                <div className="card-body">
                  <div className="table-wrapper contest-submissions-table-responsive contest-like-table-responsive">
                      <table className="table event-table contest-submissions-table contest-like-table">
                        <thead>
                          <tr>
                            <th className="registration-category-sno-col">S.No</th>
                            <th>Name</th>
                            <th>Description</th>
                            <th className="actions-col">Actions</th>
                          </tr>
                        </thead>
                        <tbody>
                          {DataList.length > 0 ? (
                            DataList.map((category, index) => (
                              <tr key={category._id}>
                                <td className="registration-category-sno-col">{index + 1}</td>
                                <td className="namecol">{category.name}</td>
                                <td className="namecol">{category.description}</td>
                                <td className="actions-col registration-category-actions-col">
                                  <div className="registration-category-actions-wrap">
                                    <Link
                                      to={`/edit-registration-category/${category._id}`}
                                      className="contest-icon-btn"
                                      title="Edit"
                                      aria-label="Edit registration category"
                                    >
                                      <FontAwesomeIcon icon={faEdit} style={{ fontSize: "13px" }} />
                                    </Link>
                                    <button
                                      type="button"
                                      className="contest-icon-btn danger"
                                      title="Delete"
                                      aria-label="Delete registration category"
                                      onClick={() =>
                                        window.confirm(
                                          "Are you sure you want to delete this category?"
                                        ) && this.deleteCategory(category._id)
                                      }
                                    >
                                      <FontAwesomeIcon icon={faTrashAlt} style={{ fontSize: "13px" }} />
                                    </button>
                                  </div>
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="4" className="table-loading-cell">No categories found.</td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                  </div>
                </div>
              </div>
          </div>
        </div>
      </div>
    );
  }
}

export default RegistrationCategories;
